import React from "react";
import Modal from "~/shared/ui/Fields/Modal";
import Button from "~/shared/ui/Fields/Button";
import { useTranslation } from "react-i18next";
import s from "./DomainsAttentionModal.less";
import { OpenModal } from "~/components/Forms/DealerPassportForm/config/types";
import { useSetLocationData } from "~/hooks/locationData";
import { usePermissions } from "~/shared/context/PermissionContext";

type Props = {
  isOpen: boolean;
  closeModal: (action: boolean) => void;
};
const DomainsAttentionModal = ({ isOpen, closeModal }: Props) => {
  const { t } = useTranslation();
  const setData = useSetLocationData();
  const { hasPermission, loading: loadingPermissions } = usePermissions();
  const handleManageDomainNames = () => {
    closeModal(!isOpen);
  };

  const handleAddDomains = () => {
    closeModal(!isOpen);
    setData("openModal", OpenModal.MANAGEDOMAINS);
  };

  return (
    <Modal
      title={t("dealers.domains_need_add")}
      isOpen={isOpen}
      actionClose={handleManageDomainNames}
    >
      <div>
        <p>{t("dealers.domains_attention")}</p>
        <div className={s.buttons}>
          {hasPermission("dealergraph.domain.check") && (
            <Button
              txtBtn={t("dealers.add_domain")}
              onClick={handleAddDomains}
              small
            />
          )}
          <Button
            txtBtn={t("ui.close")}
            onClick={handleManageDomainNames}
            small
          />
        </div>
      </div>
    </Modal>
  );
};

export default DomainsAttentionModal;
